<template>
    <div class="entrance" v-if="list.length">
        <div
            class="entrance-item"
            @click.stop="item.click?.()"
            v-for="(item, index) in list"
            :key="index"
        >
            <img class="entrance-image" :src="item.image" />
            <div class="entrance-name">{{ item.name }}</div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { pageJump } from '@/global/location-transfer';

const props = defineProps({
    classifyMap: {
        type: Object,
        default: () => {},
    },
});

let defaultList = [
    {
        name: '教育科学规划课题',
        key: 'subject',
        image: require('@/assets/img/portal/icon-research-subject.png'),
        click: () => pageJump({ name: 'scientificResearchSubject' }, true),
    },
    {
        name: '优秀成果奖',
        key: 'achievement_award',
        image: require('@/assets/img/portal/icon-result-selection.png'),
        click: () => pageJump({ name: 'scientificResearchResultSelection' }, true),
    },
    {
        name: '教学成果奖',
        key: 'achievement',
        image: require('@/assets/img/portal/icon-result-cultivation.png'),
        click: () => pageJump({ name: 'scientificResearchResultCultivation' }, true),
    },
    {
        name: '创新计划项目',
        key: 'base_school',
        image: require('@/assets/img/portal/icon-basic-school.png'),
        click: () => pageJump({ name: 'scientificResearchBasicSchool' }, true),
    },
    {
        name: '课程体系改革项目',
        key: 'studio',
        image: require('@/assets/img/portal/icon-expert-studio.png'),
        click: () => pageJump({ name: 'scientificResearchExpertStudio' }, true),
    },
    {
        name: '项目中心',
        image: require('@/assets/img/portal/icon-project-center.png'),
        click: () => pageJump({ name: 'scientificResearchProjectCenter' }, true),
    },
    {
        name: '成果中心',
        image: require('@/assets/img/portal/icon-result-center.png'),
        click: () => pageJump({ name: 'scientificResearchResultCenter' }, true),
    },
];
const list = computed(() => {
    const keys = Object.keys(props.classifyMap || {});
    return defaultList
        .filter((item, index, arr) => (item.key ? keys.includes(item.key) : true))
        .map(item => ({ ...item, name: props.classifyMap[item.key] || item.name }));
});
</script>

<style lang="scss" scoped>
.entrance {
    display: flex;
    align-items: center;
    justify-content: space-around;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 2px 2px 16px 0px rgba(15, 52, 105, 0.08);
    backdrop-filter: blur(6px);
    padding: 28px 0 20px;
    .entrance-item {
        gap: 12px;
        display: flex;
        flex-flow: column;
        align-items: center;
        cursor: pointer;
        &:hover {
            .entrance-name {
                color: rgba(22, 119, 255, 1);
            }
        }
    }
    .entrance-image {
        width: 64px;
        height: 64px;
    }
    .entrance-name {
        color: rgba(0, 0, 0, 0.88);
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
    }
}
</style>
